import { useCurrentBreakpoint } from '@hooks/useCurrentBreakpoint.hook.ts'
import { FC } from 'react'
import { LucideProps } from 'lucide-react'

export type ResponsiveIconProps = {
  className?: string
  path?: string
  menuIcon?: boolean
  Icon?: FC<LucideProps>
  iconWidth?: number
  iconHeight?: number
}

export const ResponsiveIcon: FC<ResponsiveIconProps> = ({
  Icon,
  className,
  path,
  menuIcon = false,
  iconWidth,
  iconHeight,
}) => {
  const { isMobile } = useCurrentBreakpoint()

  const width = iconWidth ? iconWidth : isMobile ? (menuIcon ? 20 : 16) : 20
  const height = iconHeight ? iconHeight : isMobile ? (menuIcon ? 20 : 16) : 20

  return Icon ? (
    <Icon className={className} size={width} />
  ) : (
    <img src={path} className={className} width={width} height={height} alt="icon" />
  )
}
